<template lang="pug">
  button.btn-link.transparent-btn.xs-f-small.max-at-tweak.color-mr-purple(@click="newPaymentModal()" data-mr-ass="account-add-payment-method")
    i.icon-pos-circle
    | Add payment method
  
</template>

<script>
  export default {
    name: "PaymentAddNewBtn",
    methods: {
      newPaymentModal() {
        this.$emit('new-payment-click');
        this.$store.dispatch('payments/editPaymentModal');
      },
    }
   }
</script>

<style scoped lang="stylus">
  button
    padding 1em 2em

</style>
